import 'angular:locale/data:lv';
import 'angular:locale/data:ru';
import 'angular:locale/data:en';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
